var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFotovoltaico(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2332_705)",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1 30.2225H31",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M29.5286 19.0902H2.47145C2.03134 19.1007 1.61069 18.9129 1.33149 18.5812C1.05244 18.2496 0.945967 17.8109 1.04287 17.3926L4.75713 2.08579C4.90687 1.43861 5.50487 0.984247 6.18571 1.00042H25.8143C26.4951 0.984247 27.0931 1.43861 27.2427 2.08579L30.957 17.3926C31.054 17.8109 30.9476 18.2496 30.6684 18.5812C30.3893 18.9129 29.9687 19.1007 29.5286 19.0902Z",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.97168 6.56616H11.7573H20.2429H28.0287",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.64307 12.1323H11.0859H20.9144H29.3573",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.2432 19.0905L11.0859 12.1329L11.7573 6.56691L12.4287 1.00073",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.757 19.0905L20.9142 12.1329L20.2427 6.56691L19.5713 1.00073",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.1432 19.0902H13.8574V30.2224H18.1432V19.0902Z",
    stroke: "#a9a9a9",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2332_705"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFotovoltaico);
export default __webpack_public_path__ + "static/media/Fotovoltaico.e050c5ee7e49a9e4fda094380d0dc3ef.svg";
export { ForwardRef as ReactComponent };